import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Heart, Users } from 'lucide-react';
export function SocialProofSection() {
  return <section className="py-20 bg-lightSage px-4" data-id="element-217">
      <div className="max-w-5xl mx-auto text-center" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-6" data-id="element-220">
            Respaldado por la Ciencia
          </h2>
          <p className="text-lg text-warmBrown max-w-3xl mx-auto mb-12" data-id="element-221">
            Esto no es solo teoría. Estos principios están respaldados por
            estudios de cronobiología y nutrición hormonal. Ya muchas mujeres
            han comenzado a aplicar estos microajustes, sintiendo cambios reales
            en su día a día.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-222">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col items-center" data-id="element-223">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm text-forest" data-id="element-224">
              <BookOpen className="w-8 h-8" data-id="element-225" />
            </div>
            <h3 className="font-heading font-bold text-lg text-forest" data-id="element-226">
              Cronobiología
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col items-center" data-id="element-227">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm text-forest" data-id="element-228">
              <Heart className="w-8 h-8" data-id="element-229" />
            </div>
            <h3 className="font-heading font-bold text-lg text-forest" data-id="element-230">
              Nutrición Hormonal
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex flex-col items-center" data-id="element-231">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm text-forest" data-id="element-232">
              <Users className="w-8 h-8" data-id="element-233" />
            </div>
            <h3 className="font-heading font-bold text-lg text-forest" data-id="element-234">
              Comunidad de Mujeres
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}